import { render, staticRenderFns } from "./AddressSection.vue?vue&type=template&id=79c0d86f&scoped=true&"
import script from "./AddressSection.vue?vue&type=script&setup=true&lang=ts&"
export * from "./AddressSection.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./AddressSection.vue?vue&type=style&index=0&id=79c0d86f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79c0d86f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79c0d86f')) {
      api.createRecord('79c0d86f', component.options)
    } else {
      api.reload('79c0d86f', component.options)
    }
    module.hot.accept("./AddressSection.vue?vue&type=template&id=79c0d86f&scoped=true&", function () {
      api.rerender('79c0d86f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/info/document/index/components/AddressSection.vue"
export default component.exports